import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface TextProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
}

/** Small monospace kicker above a heading. */
export function Eyebrow({ className, children, ...props }: TextProps) {
  return (
    <p
      className={cn(
        'mb-1 font-mono text-[10px] uppercase tracking-[0.1em] text-accent',
        className,
      )}
      {...props}
    >
      {children}
    </p>
  );
}

/** Muted monospace metadata — kickoff times, club names, helper copy. */
export function Meta({ className, children, ...props }: TextProps) {
  return (
    <span className={cn('font-mono text-[11px] text-content-muted', className)} {...props}>
      {children}
    </span>
  );
}

/** Uppercase micro-label sitting above a figure. */
export function FieldLabel({ className, children, ...props }: TextProps) {
  return (
    <span
      className={cn(
        'font-mono text-[10px] uppercase tracking-[0.12em] text-content-muted',
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
